import { Box, SpaceVertical } from '@looker/components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import { useLottie } from 'lottie-react';
import type React from 'react';
import animJSON from '../assets/cowWave.json';

interface ICowWaveLoader {
  loadingText?: string;
  centered?: boolean;
}

export const CowWaveLoader: React.FC<ICowWaveLoader> = ({ loadingText, centered = true }) => {
  const options = {
    animationData: animJSON,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options);

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      position={'absolute'}
      zIndex={1000}
      top={0}
      left={centered ? 0 : '20vw'}
      right={0}
      bottom={0}
      style={{ pointerEvents: 'none' }}
    >
      <SpaceVertical
        width={'204px'}
        borderRadius={'100px'}
        justify="center"
        align="center"
        style={{ pointerEvents: 'none' }}
        padding="u8"
      >
        {View}
        {loadingText ? <DsTypography variant="caption">{loadingText}</DsTypography> : null}
      </SpaceVertical>
    </Box>
  );
};
